import { Controller } from "@hotwired/stimulus";

// Placeholder – kept so the data-controller wire isn't dangling.
// Extend when search-form needs client-side behaviour again.
export default class extends Controller {
  static targets = ["input"];
}
